import { unref } from 'vue'
import type { MaybeRef } from 'vue'

type TableColumn = {
  key: string
  label: string
  hidden?: boolean
}

type UseTableExportOptions = {
  columns: MaybeRef<TableColumn[]>
  items: MaybeRef<Record<string, unknown>[]>
  filenamePrefix: string
  includeHidden?: boolean
}

export const useTableExport = ({ columns, items, filenamePrefix, includeHidden = true }: UseTableExportOptions) => {
  const createExportFilename = (prefix: string) => {
    const date = new Date().toISOString().slice(0, 10)
    return `${prefix}-${date}.csv`
  }

  const exportCsv = () => {
    const cols = unref(columns).filter((col) => includeHidden || !col.hidden)
    const rows = unref(items).map((item) => cols.map((col) => item[col.key] ?? ''))
    const header = cols.map((c) => c.label ?? c.key)
    const escape = (v: unknown) => `"${String(v ?? '').replace(/"/g, '""')}"`
    const csv = [header, ...rows].map((r) => r.map(escape).join(',')).join('\n')

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = createExportFilename(filenamePrefix)
    a.click()
    URL.revokeObjectURL(url)
  }

  return { exportCsv }
}
